import {
    FETCH_REQUEST_ORDER,
    RESET_REQUEST_ORDER,
  } from "../../constants/action.constants";
  
  const initialState = {
    data: {},
    others: {},
  };
  
  const requestOrderView = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_REQUEST_ORDER:
        return { data: action.payload, others: action.others };
      case RESET_REQUEST_ORDER:
        return initialState;
      default:
        return state;
    }
  };
  
  export default requestOrderView;
  